import React from 'react';

export default function YouTubeIcon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="23" height="16" viewBox="0 0 23 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.86056 11.3196V4.85862L15.3767 8.08911L8.86056 11.3196ZM22.3993 3.48511C22.2642 2.00172 21.0488 0.825996 19.5295 0.694139C17.7626 0.551294 15.1516 0.397461 11.9217 0.397461C8.03901 0.397461 5.10169 0.551294 3.211 0.694139C1.68044 0.815008 0.453736 2.00172 0.318687 3.48511C0.206145 4.68281 0.104858 6.2541 0.104858 8.13307C0.104858 9.96807 0.206145 11.5064 0.318687 12.6931C0.453736 14.1875 1.68044 15.3632 3.19974 15.4841C5.10169 15.6269 8.03901 15.7808 11.9217 15.7808C15.1516 15.7808 17.7626 15.6269 19.5295 15.4841C21.0488 15.3522 22.2642 14.1765 22.3993 12.6931C22.5118 11.5174 22.6131 9.9461 22.6131 8.08911C22.6131 6.23213 22.5118 4.66083 22.3993 3.48511Z"></path>
    </svg>
  );
}
